<template>
  <div class="wrapper wrapper-default main-botbtn">
    <!-- 头部s -->
    <s-header :getlogin="islogin">{{title}}</s-header>
    <!-- 头部e -->

    <div class="message-detail">
      <div class="message-detail-top">
        <div class="message-detail-tit">商机信息</div>
        <ul class="message-detail-list">
          <li class="flexBox">
            <span class="message-detail-list-tit">采购产品：</span>&nbsp;
            <span class="flex1">{{products.productname || '-'}}</span>
          </li>
          <li>
            <span class="message-detail-list-tit">产品类型：</span>
            {{products.categoryName || '-'}}
          </li>
          <li>
            <span class="message-detail-list-tit">采购数量：</span>
            {{detail.totalProd}}{{products.unit}}
          </li>
          <li>
            <span class="message-detail-list-tit">商机留言：</span>
            {{products.remark || '-'}}
          </li>
          <li>
            <span class="message-detail-list-tit">接收时间：</span>
            {{detail.createtime | formatDate(`yyyy-MM-dd`)}}
          </li>
        </ul>
      </div>
      <div class="message-detail-bot">
        <div class="message-detail-tit">买家信息</div>
        <ul class="message-detail-list">
          <li>
            <span class="message-detail-list-tit">买家姓名：</span>
            {{detail.contact || detail.buyerComp || '匿名买家'}}
          </li>
          <li>
            <span class="message-detail-list-tit">联系电话：</span>
            <span class="message-detail-list-phone" @click="phoneCall">&nbsp;{{detail.mobile}}</span>
          </li>
        </ul>
      </div>

      <!-- 底线s -->
      <s-divider></s-divider>
      <!-- 底线e -->
    </div>

    <div class="message-detail-call fixWrap van-hairline--top">
      <div
        class="message-detail-call-btn flexBox flexAlignCenter flexJustifyCenter"
        @click="phoneCall"
      >
        <i class="icon-ring"></i>
        <span>拨打电话</span>
      </div>
    </div>

    <!-- 电话提示s -->
    <phonecall-tip :show.sync="showPhoneTip" :phoneNum="detail.mobile"></phonecall-tip>
    <!-- 电话提示e -->
  </div>
</template>
<script>
import phonecallTip from "../../components/phonecallTip";
export default {
  metaInfo: {
    title: "商机详情"
  },
  components: {
    phonecallTip: phonecallTip
  },
  data() {
    return {
      baseLink: process.env.VUE_APP_BASE_LINK,
      title: "商机详情",
      showPhoneTip: false,
      detail: {},
      products: {},
      islogin: false
    };
  },
  methods: {
    phoneCall() {
      this.showPhoneTip = true;
    }
  },
  async created() {
    let abc = {
      wantOrderId: this.$route.query.wantOrderId,
      id: this.$route.query.id
    };
    let res = await this.$axios.get("/enquiryDetails.json", { params: abc });
    this.detail = res.data;
    this.products = res.data.products[0];
    this.islogin = res.success ? true : false;
  }
};
</script>
<style lang="less">
@import "../../assets/css/ucenter";
</style>
